import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-texto',
  templateUrl: './texto.component.html',
  styleUrls: ['./texto.component.scss'],
})
export class TextoComponent {

  @Input() texto: string;
  @Input() titulo: string;
  @Input() color = 'medium';

  constructor(
      public modalCtrl: ModalController
  ) {}

}
